import { AVATAR_MAX_INITIALS } from './constants';

export const getUserInitials = (fullname: string): string => {
  return fullname
    .split(' ')
    .map(name => name.charAt(0))
    .join('')
    .toUpperCase()
    .slice(0, AVATAR_MAX_INITIALS);
};

export const createNavGroupId = (label: string): string => {
  return `nav-group-${label.toLowerCase().replace(/\s+/g, '-')}`;
};
